import _, { cloneWith, result } from "lodash";

import * as getVenueCampaigns from '@/api/crm/venueCampaigns/getVenueCampaigns';
import * as getVenueCampaignsForMasterCampaign from '@/api/crm/venueCampaigns/getVenueCampaignsForMasterCampaign';
import * as getVenueCampaign from '@/api/crm/venueCampaigns/getVenueCampaign';
import * as updateVenueCampaign from '@/api/crm/venueCampaigns/updateVenueCampaign';
import * as submitForApproval from '@/api/crm/venueCampaigns/submitForApproval';
import * as approveCampaign from '@/api/crm/venueCampaigns/approveCampaign';
import * as rejectCampaign from '@/api/crm/venueCampaigns/rejectCampaign';
import * as resetFromMasterCampaign from '@/api/crm/venueCampaigns/resetFromMasterCampaign';
import * as getPreviewData from '@/api/crm/venueCampaigns/getPreviewData';

export default {
    namespaced: true,
    state: {
        loading: false,
        venueCampaigns: [],
        venueCampaignsForMaster: [],
        venueCampaign: null,
        venueCampaignEmailPreviewHtml: "",
        venueCampaignSmsPreviewContent: "",
    },
    mutations: {
        gotAll(state, venueCampaigns) {
            state.venueCampaigns = venueCampaigns;
        },
        gotVenueCampaignsForMaster(state, venueCampaigns) {
            console.log(venueCampaigns);
            state.venueCampaignsForMaster = venueCampaigns;
        },
        gotSingle(state, venueCampaign) {
            state.venueCampaign = venueCampaign;
            console.log(venueCampaign);
        },
        gotPreviewData(state, data) {
            if (data != null) {
                state.venueCampaignEmailPreviewHtml = data.item1;
                state.venueCampaignSmsPreviewContent = data.item2;
            } else {
                state.venueCampaignEmailPreviewHtml = "";
                state.venueCampaignSmsPreviewContent = "";
            }
        }
    },
    actions: {
        async getForVenue({ commit }, venueId) {
            const result = await getVenueCampaigns.get(venueId);
            if (result) {
                commit("gotAll", result);
                commit("gotSingle", null);
            }
        },

        async getForMasterCampaign({ commit }, masterCampaignId) {
            const result = await getVenueCampaignsForMasterCampaign.get(masterCampaignId);
            if (result) commit("gotVenueCampaignsForMaster", result);
        },

        async get({ commit }, venueCampaignId) {
            commit("gotSingle", null);
            const result = await getVenueCampaign.get(venueCampaignId);
            if (result) commit("gotSingle", result);
        },

        async getPreviewHtml({ commit }, venueCampaignId) {
            commit("gotPreviewData", null);
            const result = await getPreviewData.get(venueCampaignId);
            if (result) commit("gotPreviewData", result);
        },

        async update({ dispatch }, dto) {
            await updateVenueCampaign.put(dto);
        },

        async submitForApproval({ dispatch }, venueCampaignId) {
            console.log("Submitting", venueCampaignId);
            await submitForApproval.post(venueCampaignId);
            dispatch("get", venueCampaignId);
        },
        async approve({ dispatch }, venueCampaign) {
            await approveCampaign.post(venueCampaign.id);
            dispatch("getForMasterCampaign", venueCampaign.masterId);
        },
        async reject({ dispatch }, venueCampaign) {
            await rejectCampaign.post(venueCampaign.id, venueCampaign.rejectedComment);
            dispatch("getForMasterCampaign", venueCampaign.masterId);
        },

        async resetFromMaster({ dispatch }, venueCampaignId) {
            console.log("Resetting", venueCampaignId);
            await resetFromMasterCampaign.post(venueCampaignId);
            dispatch("get", venueCampaignId);
        },

    },
    getters: {
        all: state => state.venueCampaigns,
        pendingCampaigns: state => state.venueCampaigns.filter(e => e.status == "ReadyToFillOut" || e.status == "SubmittedForApproval" || e.status == "Rejected" || e.status == "Approved"),
        sentCampaigns: state => state.venueCampaigns.filter(e => e.status == "Sent" || e.status == "NotSent" || e.status == "ErrorSending"),
        venueCampaign: state => state.venueCampaign,
        masterVenueCampaigns: state => state.venueCampaignsForMaster,
        emailPreviewHtml: state => state.venueCampaignEmailPreviewHtml,
        smsPreviewContent: state => state.venueCampaignSmsPreviewContent,
    }
};
